// mds-dojo — dijit/form/DateTextBox — FAITHFUL port of references/dijit/form/DateTextBox.js
// (BSD-3, © JS Foundation). Codemod pipeline; declare from the faithful runtime.
// ADAPTATION: `dojo/_base/declare` → `../../dojo/_base/declare-runtime`; `dijit/X` → `../X`.
import declare from '../../dojo/_base/declare-runtime'; // declare
import Calendar from '../Calendar';
import _DateTimeTextBox from './_DateTimeTextBox';

// module:
//		dijit/form/DateTextBox

export default declare("dijit.form.DateTextBox", _DateTimeTextBox, {
	// summary:
	//		A validating, serializable, range-bound date text box with a drop down calendar
	// example:
	// |	new DateTextBox({value: new Date(2009, 0, 20)})
	// example:
	// |	<input data-dojo-type='dijit/form/DateTextBox' value='2009-01-20'>

	baseClass: "dijitTextBox dijitComboBox dijitDateTextBox",
	popupClass: Calendar,
	_selector: "date",

	// Prevent scrollbar on Calendar dropdown.  On iPad it often gets a scrollbar unnecessarily because Viewport
	// thinks the keyboard is showing.  Even if the keyboard is showing, it disappears when the calendar gets focus.
	maxHeight: Infinity,

	// value: Date
	//		The value of this widget as a JavaScript Date object, with only year/month/day specified.
	//		If specified in markup, use the format specified in `stamp.fromISOString`.
	//		set("value", ...) accepts either a Date object or a string.
	value: new Date("")	// value.toString()="NaN"
});
